/**
 * Text formatting utilities for analysis display
 * Converts markdown-style formatting to HTML
 */

/**
 * Convert *text* to <em>text</em>
 */
export function formatAsterisks(text: string): string {
  return text.replace(/\*([^*]+)\*/g, '<em>$1</em>');
}

/**
 * Convert "text" (straight or curly quotes) to « <em>text</em> »
 * Uses non-breaking spaces as per French typography rules
 */
export function formatQuotes(text: string): string {
  // Handle straight quotes
  let result = text.replace(/"([^"]+)"/g, '«\u00A0<em>$1</em>\u00A0»');
  // Handle curly quotes
  result = result.replace(/"([^""]+)"/g, '«\u00A0<em>$1</em>\u00A0»');
  return result;
}

/**
 * Apply all text formatting transformations
 * Order: asterisks first (they may appear inside quotes)
 */
export function formatAnalysisText(text: string): string {
  let result = formatAsterisks(text);
  result = formatQuotes(result);
  return result;
}
